import { Checkbox } from "@design-system/Checkbox/Checkbox";
import { HStack } from "@design-system/HStack/HStack";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { InfoIcon } from "@icons";
import { MigratedScheduleOption } from "./useMigratedScheduleOption";
import styles from "./MigratedScheduleCheckbox.module.scss";

export const MIGRATED_SCHEDULE_LABEL = "Migrated from previous books";

export const MIGRATED_SCHEDULE_TOOLTIP =
    "Select if the opening entry is already in your books; Kick will skip and post only the monthly entries. Enter the remaining balance and period on the start date.";

export const MigratedScheduleCheckbox = ({
    option,
}: {
    option: MigratedScheduleOption;
}) => (
    <HStack gap={4} align="center">
        <Checkbox
            label={MIGRATED_SCHEDULE_LABEL}
            checked={option.isChecked}
            onCheckedChange={option.onCheckedChange}
        />
        <Tooltip content={MIGRATED_SCHEDULE_TOOLTIP}>
            <button
                type="button"
                aria-label="More information"
                className={styles.infoButton}
            >
                <InfoIcon aria-hidden />
            </button>
        </Tooltip>
    </HStack>
);
